/**
 * Consent to the Terms of Use and Privacy Policy.
 *
 * Many learners are under 18, and POPIA treats a person under 18 as a child
 * whose personal information may be processed only with a parent's or
 * guardian's consent. So on first sign-in the app asks which of two things is
 * true and records the answer, the date, and which version of the documents was
 * accepted.
 *
 * `CURRENT_CONSENT_VERSION` is what a user must have accepted. Bump it when the
 * Terms or Privacy Policy change in a way people should agree to again, and
 * everyone is asked once more on their next visit. Do not bump it for a typo:
 * that would make every user re-accept unchanged terms.
 *
 * The value is the `updated` date of the public pages in apps/www/content.
 */
export const CURRENT_CONSENT_VERSION = "2026-09-21";
/**
 * Who is agreeing. "adult" is someone 18 or over agreeing for themselves;
 * "guardian" is a learner under 18 whose parent or guardian has agreed for them.
 */
export const CONSENT_BASES = ["adult", "guardian"];
